export class LocalizationService {

    public strings = [
        {
            column: 'firstname',
            ru: 'Имя',
            en: 'First Name'
        },
        {
            column: 'lastname',
            ru: 'Фамилия',
            en: 'Last Name'
        },
        {
            column: 'address',
            ru: 'Адрес',
            en: 'Address'
        },
        {
            column: 'address1',
            ru: 'Адрес 1',
            en: 'Address 1'
        },
        {
            column: 'address1',
            ru: 'Адрес 1',
            en: 'Address 1'
        },
        {
            column: 'address2',
            ru: 'Адрес 2',
            en: 'Address 2'
        },
        {
            column: 'city',
            ru: 'Город',
            en: 'City'
        },
        {
            column: 'country',
            ru: 'Страна',
            en: 'Country'
        },
        {
            column: 'province',
            ru: 'Провинция/Штат',
            en: 'Province/State'
        },
        {
            column: 'postal',
            ru: 'Почтовый индекс',
            en: 'Postal code'
        },
        {
            column: 'required',
            ru: 'Обязательное поле',
            en: 'Required field'
        },
        {
            column: 'inputRestrictions',
            ru: 'Только латинские символы',
            en: 'Only Latin symbols allowed'
        },
        {
            column: 'lengthRestrictions',
            ru: 'Длина должна находиться в диапазоне от 2 до 100 символов',
            en: 'Field must contains from 2 to 100 symbols'
        },
        {
            column: 'select',
            ru: '- Выбрать -',
            en: '- Select -'
        },
        {
            column: 'countryRestrictions',
            ru: 'Выберите страну',
            en: 'Select country'
        },
        {
            column: 'postalRestrictions',
            ru: 'Почтовый индекс должен соответствовать канадскому формату',
            en: 'Postal code must be canadian'
        },
        {
            column: 'inputAddress',
            ru: 'Введите адрес...',
            en: 'Enter address...'
        },
        {
            column: 'serviceRestrictions',
            ru: 'Мы не предоставляем услуги на территории выбранной страны',
            en: 'Service is not available for selected country'
        },
        {
            column: 'editAddress',
            ru: 'Редактировать адрес',
            en: 'Edit address'
        },
        {
            column: 'restrictForAddress',
            ru: 'Адрес должен состоять только из латинских символов',
            en: 'Only Latin symbols allowed'
        },
        {
            column: 'restrictForCity',
            ru: 'Город должен состоять только из латинских символов',
            en: 'Only Latin symbols allowed'
        },
        {
            column: 'restrictForPostal',
            ru: 'Индекс должен стостоять из латинских симловов и цифр',
            en: 'Only Latin symbols allowed'
        },
    ];

    public getLocalized(text: string, locale: string) : string {
        const filter = this.strings.filter((x: any) => x.column === text);
        if (filter.length < 0) {
            return text;
        } else {
            return (<any>filter[0])[locale];
        }
    }
}


// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/localization.ts